import keyMirror from 'keymirror';

const types = keyMirror({
	REFRESH_ADJUSTMENT_TYPE_LIST: null,
	UPDATE_ADJUSTMENT_TYPE_NAME: null,
  DELETE_ADJUSTMENT_TYPE: null,
  ADD_ADJUSTMENT_TYPE: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/SalaryConstants.js